<table class="subwindow" [cdkDragConstrainPosition]="constrainPosition" plessTitleWindowSub cdkDrag [windowMovable]="false" [windowResizable]="false">
  <tr class="subwindow-title" cdkDragHandle>
    <th class="window-title-name">関連Pコード設定</th>
    <!-- ダイアログ閉じるボタンを最後にフォーカスしたいため最後方に移動済 -->
  </tr>

  <tr class="subwindow-body" style="height: 120px;">
    <td style="height: 120px;">
      <div class="contents-area" (dragstart)="onDragstartBody($event)">
        <!-- 関連Pコード一覧 -->
        <wj-flex-grid #dg_relatedInfo id="dg_relatedInfo" [itemsSource]="kymw0600Model.relatedGoodsList"
          [headersVisibility]="'Column'" [style.width.px]="1055" [style.height.px]="115" [isReadOnly]="true"
          [tabindex]="0" [allowSorting]="false">
          <wj-flex-grid-column [minWidth]="5" [header]="' '" [width]="30" [binding]="'oldNew'" [align]="'center'"></wj-flex-grid-column>
          <wj-flex-grid-column [minWidth]="5" [header]="'Ｐコード'" [width]="85" [binding]="'pCode'" [align]="'left'"></wj-flex-grid-column>
          <wj-flex-grid-column [minWidth]="5" [header]="'商品名'" [width]="312" [binding]="'goodsName'" [align]="'left'"></wj-flex-grid-column>
          <wj-flex-grid-column [minWidth]="5" [header]="'規格名'" [width]="148" [binding]="'guideStandardName'" [align]="'left'"></wj-flex-grid-column>
          <wj-flex-grid-column [minWidth]="5" [header]="'メーカー名'" [width]="140" [binding]="'makerName'" [align]="'left'"></wj-flex-grid-column>
          <wj-flex-grid-column [minWidth]="5" [header]="'支払先取引先'" [width]="180" [binding]="'displaySupplier'" [align]="'left'"></wj-flex-grid-column>
          <wj-flex-grid-column [minWidth]="5" [header]="'本登録日時'" [width]="140" [binding]="'regularRegistDate'" [align]="'left'"></wj-flex-grid-column>
        </wj-flex-grid>

        <div>
          <h1>候補一覧</h1>
          <button id="btn_Search" #btn_Search class="btn-secondary" 
              [tabindex]="0" (click)="eventSeach_CLICKHandler()">商品検索</button>
          <!-- 候補一覧エリア -->
          <wj-flex-grid #dg_candidateInfo id="dg_candidateInfo" [itemsSource]="kymw0600Model.targetGoodsList"
            [headersVisibility]="'Column'" [style.width.px]="1055" [style.height.px]="142" [isReadOnly]="true"
            [tabindex]="0" [allowSorting]="false">
            <wj-flex-grid-column [minWidth]="5" [header]="'Ｐコード'" [width]="85" [binding]="'pCode'" [align]="'left'">
            </wj-flex-grid-column>
            <wj-flex-grid-column [minWidth]="5" [header]="'商品名'" [width]="312" [binding]="'goodsName'" [align]="'left'">
              <ng-template wjFlexGridCellTemplate [cellType]="'Cell'" let-cell="cell">
                <div [align]="'left'">{{cell.item.goodsName}}</div>
              </ng-template>
            </wj-flex-grid-column>
            <wj-flex-grid-column [minWidth]="5" [header]="'規格名'" [width]="178" [binding]="'guideStandardName'"
              [align]="'left'">
              <ng-template wjFlexGridCellTemplate [cellType]="'Cell'" let-cell="cell">
                <div [align]="'left'">{{cell.item.guideStandardName}}</div>
              </ng-template>
            </wj-flex-grid-column>
            <wj-flex-grid-column [minWidth]="5" [header]="'メーカー名'" [width]="140" [binding]="'makerName'"
              [align]="'left'">
              <ng-template wjFlexGridCellTemplate [cellType]="'Cell'" let-cell="cell">
                <div [align]="'left'">{{cell.item.makerName}}</div>
              </ng-template>
            </wj-flex-grid-column>
            <wj-flex-grid-column [minWidth]="5" [header]="'支払先取引先'" [width]="180" [binding]="'displaySupplier'"
              [align]="'left'">
              <ng-template wjFlexGridCellTemplate [cellType]="'Cell'" let-cell="cell">
                <div [align]="'left'">{{cell.item.displaySupplier}}</div>
              </ng-template>
            </wj-flex-grid-column>
            <wj-flex-grid-column [minWidth]="5" [header]="'本登録日時'" [width]="140" [binding]="'regularRegistDate'"
              [align]="'left'">
            </wj-flex-grid-column>
          </wj-flex-grid>  
        </div>
      </div>
    </td>
  </tr>

  <tfoot cdkDragHandle>
    <tr>
      <td>
        <div class="footer-buttons">
          <button id="btn_Update" class="btn-primary" (click)="eventBtnUpdate_CLICKHandler(null)" 
            [tabindex]="0" [disabled]="kymw0600Model.enabledUpdate">更新</button>
        </div>
        <div class="window-title-close">
          <!-- ダイアログ閉じるボタンを最後にフォーカスしたいため最後方に移動済 -->
          <button [tabindex]="0" (click)="eventBtnClose_CLICKHandler()"></button>
        </div>
      </td>
    </tr>
  </tfoot>
</table>